export const userTypes = {
  SET_LOADER_VISIBLE: 'USER/SET_LOADER_VISIBLE',
  SET_USER_DATA: 'USER/SET_USER_DATA',
} as const;

export const otherTypes = {
};
